import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconFlag({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path fill="none" d="m11.58 10.4 2.09-5.02" />
			<path
				fill="#e42822"
				d="M13.29 5.22c.09-.21.33-.31.55-.23.2.09.31.31.24.52v.03l-2.1 5.02c-.09.21-.33.31-.55.23a.425.425 0 0 1-.24-.52v-.03z"
			/>
			<path fill="none" d="m9.91 7.48 5.44.83" />
			<path
				fill="#e42822"
				d="M9.49 7.41c.03-.22.23-.37.45-.35h.03l5.44.84c.23.04.39.25.35.48-.03.22-.23.37-.45.35h-.03l-5.44-.84a.42.42 0 0 1-.35-.48"
			/>
			<g fill="#fefefe">
				<path d="M6.36 3.68c.21-.08.44.02.53.22v.03l6.95 18.39c.08.22-.03.46-.24.54a.417.417 0 0 1-.53-.22v-.03L6.11 4.22c-.08-.22.03-.46.24-.54Z" />
				<path d="M6.14 1.67c-.79.01-1.43.67-1.42 1.46s.67 1.43 1.46 1.42c.78-.01 1.41-.64 1.42-1.42v-.04c-.01-.79-.67-1.43-1.46-1.42m.01.84c.32 0 .59.24.61.56v.03c0 .33-.26.61-.59.61s-.61-.26-.61-.59.26-.61.59-.61M16.62 1.14c.22-.08.46.03.54.24 2.12 5.6-.71 11.87-6.31 13.98a.42.42 0 0 1-.54-.24c-.08-.22.03-.46.24-.54 5.17-1.96 7.78-7.73 5.82-12.91-.08-.22.03-.46.24-.54Z" />
				<path d="M16.4 1.33c.11-.2.37-.27.57-.16s.27.37.16.57c-.55.98-1.27 1.63-2.18 2.01-.55.23-1.13.36-1.87.43l-.19.02h-.3s-.07.02-.1.02l-.35.02-.63.02h-.23l-.28.02h-.13l-.18.02h-.11l-.11.02h-.1l-.1.02h-.1l-.09.03h-.09l-.09.03-.08.02h-.04l-.08.02-.08.02-.08.02-.08.02-.08.02-.08.03s-.03 0-.04.01c-.74.28-1.25.79-1.6 1.67a.417.417 0 1 1-.78-.3c.43-1.1 1.13-1.78 2.09-2.14l.09-.03s.03-.01.04-.02l.09-.03s.09-.03.13-.04l.09-.02s.06-.02.09-.02l.09-.02s.03 0 .05-.01l.09-.02s.06-.01.1-.02l.1-.02h.15l.11-.03h.11l.12-.02h.12l.13-.02h.13l.14-.02h.14l.31-.02.85-.03h.12l.16-.01h.16l.16-.02h.15l.15-.03c1.62-.18 2.55-.7 3.27-2Z" />
			</g>
			<path
				fill="#fefefe"
				d="M13.36 13.3c.17-.14.42-.12.57.04l.02.02 1.45 1.8c.14.18.12.44-.06.59-.17.14-.42.12-.57-.04l-.02-.02-1.45-1.8a.425.425 0 0 1 .06-.59"
			/>
			<g fill="#fefefe">
				<path d="M16.18 9.23c.1-.2.33-.29.53-.21h.03l1.8.87a.42.42 0 0 1-.33.77h-.03l-1.8-.87a.42.42 0 0 1-.2-.56M19.27 3.85a.423.423 0 0 1 .09.84h-.03l-1.89.14a.423.423 0 0 1-.09-.84h.03z" />
			</g>
		</svg>
	);
}
